export interface IAppVersionCheckRequest {
    name?: string
    id?: string
    build?: string
    version: string
    os?: string
    language?: string
    timezone?: string
}

export interface IAppVersionCheckResponse {
    isSupported: boolean
    isLatest: boolean
    downloadUrl: string
}

export enum EAppVersionCheckDecision {
    UpToDate = 0,
    UpdateAvailable = 1,
    NotSupported = 2
}
